import DocumentDetailsStep from './DocumentDetailsStep';

export default DocumentDetailsStep;
